export const homeObjectOne = {
  primary: true,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topline: "Farm 2 Fork",
  headline:
    "Best Quality Ingredients and Kitchen Products, Delivered Hassle Free.",
  description: "No Pesticides | No Chemicals | No Hormones",
  buttonLabel: "Get Started",
  imgStart: "",
  img: require("../../assets/images/undraw_shopping_app_flsj.svg"),
  alt: "Virtual Aisle",
  start: "",
};
export const homeObjectTwo = {
  primary: false,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topline: "Why Organi-KA ?",
  headline: "Quality, Single Vendor, Next Day Delivery",
  buttonLabel: "Register",
  imgStart: "start",
  img: require("../../assets/images/undraw_Delivery_re_f50b.svg"),
  alt: "Virtual Aisle",
  start: "true",
};
export const homeObjectThree = {
  primary: true,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topline: "Just about any food item and more!",
  headline: "What can you buy?",
  description:
    "Fruits | Vegetables | Groceries | Dairy | Poultry | Meat |  Sea Food | Beverage | Bar | Gourmet | Bakery",
  buttonLabel: "Add to Your Cart",
  imgStart: "",
  img: require("../../assets/images/undraw_healthy_options_sdo3.svg"),
  alt: "Virtual Aisle",
  start: "",
};
export const homeObjectFour = {
  primary: false,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  headline: "How it works?",
  description:
    "Select from Over 1200+ ingredients & Kitchen Products. Place the Order and Pay via Credit Card, Debit Card, Netbanking or UPI.",
  imgStart: "start",
  img: require("../../assets/images/undraw_folder_39kl.svg"),
  alt: "Virtual Aisle",
  start: "true",
  buttonLabel: "Sign Up",
};
